/* eslint-disable react/prop-types */
import React, { Fragment, useEffect, useRef, useState } from "react";
import { Button, CircularProgress } from "@material-ui/core";
import ControlledDialog from "../../../../components/ControlledDialog/ControlledDialog";

const MnpPrintLabelPdfView = (props) => {
  const { handleClose, open, consignmentNumber } = props;
  const iframeRef = useRef(null);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(false);
  }, [props.consignmentNumber]);

  const handleOpenWindow = (e, cn = "544794010101501") => {
    const baseUrl = "https://mnpcourier.com/mycodapi/GetAddressLabel_HTML.aspx";
    const dummyText = encodeURIComponent(
      "$12$B45r4dEcLl0wfUf6VCDiCqKQy/9U49Kqy8gQt1qPzjj$12$B45r4dEcLl0wfUf6VCDiCqKQy/9U49Kqy8gQt1qPzjjLnO8VzKoq$12$B45r4dEcLl0wfUf6VCDiCqKQy/9U49Kqy8gQt1qPzjjLnO8VzKoq$12$B45r4dEcLl0wfUf6VCDiCqKQy/9U49Kqy8gQt1qPzjjLnO8VzKoqLnO8VzKoq"
    );
    const queryString = `con=${cn}&tt=${dummyText}1&_pasword=${dummyText}2&psw=${"SecUrE@123"}&_12345_=${dummyText}3&password=${
      process.env.REACT_APP_MNP_PASSWORD
    }&p=${"$12$B45r4dEcLl0wfUf6VCDiCqKQy/9U49Kqy8gQt1qPzjjLnO8VzKoq"}&_12345=${dummyText}4&UserId=${
      process.env.REACT_APP_MNP_USERNAME
    }&u=${"SecureProfile@Ck"}&User_Id=${dummyText}5&labeltype=1&en=English`;

    const encodedUrl = `${baseUrl}?${queryString}`;
    const printWindow = window.open(encodedUrl, "_blank");
    if (printWindow) {
      props.handlePrint(null, true);
      // Inform the user
      printWindow.focus();
      printWindow.print();
    } else {
      console.error("Failed to open the print window.");
    }
  };

  return (
    <Fragment>
      <ControlledDialog
        isFullScreen={true}
        open={open}
        fullWidth
        handleClose={() => {
          setIsLoaded(false);
          handleClose();
        }}
        title={
          <Fragment>
            <span
              style={{
                fontSize: 18,
                color: "#1558a2",
                fontWeight: 700,
              }}
            >
              Delivery Partner Shipping Label
            </span>
          </Fragment>
        }
        content={
          <Fragment>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  width: "100%",
                }}
              >
                <div
                  style={{
                    marginRight: 20,
                  }}
                >
                  {!isLoaded
                    ? "Shipping label getting from server..."
                    : "When you click on print button and new tab will open when content loaded successfully in new tab then press CTRL + P button to print label."}
                </div>
                {!isLoaded && <CircularProgress size={22} />}
              </div>
              <Button
                onClick={(e) => handleOpenWindow(e, consignmentNumber)}
                id="btnShippingLabelPrint"
                style={{
                  textTransform: "capitalize",
                  opacity: 0.8,
                  float: "right",
                  zIndex: 1000,
                  marginBottom: 20,
                }}
                disabled={!isLoaded}
                color="primary"
                variant="contained"
              >
                Print
              </Button>
            </div>
            <iframe
              onLoad={() => {
                setIsLoaded(true);
              }}
              id="my-iframe"
              ref={iframeRef}
              src={`https://mnpcourier.com/mycodapi/GetAddressLabel_HTML.aspx?con=${consignmentNumber}&UserID=${process.env.REACT_APP_MNP_USERNAME}&password=${process.env.REACT_APP_MNP_PASSWORD}&labeltype=1`}
              title="Address Label"
              style={{
                width: "100%",
                height: "600px",
                border: "1px solid #ccc",
              }}
            ></iframe>
          </Fragment>
        }
      />
    </Fragment>
  );
};

export default MnpPrintLabelPdfView;
